// @ts-nocheck

import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import FiltersWrapper from '../../../components/FiltersWrapper';
import MatchBetFilter from '../../../components/MatchBetFilter';
import { __ } from '../../../i18n/l10n';
import HallOfFameItemContainer from '../containers/HallOfFameItemContainer';

const HallOfFameWrapper = styled.div``;

const HallOfFameFilters = styled(FiltersWrapper)``;

const HallOfFameItems = styled.div`
  margin: 0 0.6em;
`;

const FILTERS = [
  {
    // __('Biggest winnings')
    labelKey: 'Biggest winnings',
    id: 'biggestWinningsSimple',
  },
  {
    // __('Highest MyMatch odds')
    labelKey: 'Highest MyMatch odds',
    id: 'biggestMymatch',
  },
  {
    // __('Highest odds')
    labelKey: 'Highest odds',
    id: 'biggestOdds',
  },
  {
    // __('Biggest accumulators')
    labelKey: 'Biggest accumulators',
    id: 'biggestCombo',
  },
];

const HallOfFame = ({ matchId, hallOfFameBetslipsIds }) => {
  const [selectedFilter, setSelectedFilter] = useState(FILTERS[0].id);

  useEffect(() => {
    const filter = FILTERS.find((f) => hallOfFameBetslipsIds[f.id].length);

    if (filter) {
      setSelectedFilter(filter.id);
    }
  }, [hallOfFameBetslipsIds]);

  const handleFilterClick = useCallback((filter) => {
    setSelectedFilter(filter);
  }, []);

  if (!hallOfFameBetslipsIds) {
    return null;
  }

  if (matchId) {
    return (
      <HallOfFameWrapper>
        <HallOfFameFilters>
          {FILTERS.map((filter) => {
            const nbrBets = hallOfFameBetslipsIds[filter.id].length;

            if (!nbrBets) {
              return null;
            }

            return (
              <MatchBetFilter
                key={filter.id}
                onClick={() => handleFilterClick(filter.id)}
                isSelected={filter.id === selectedFilter}
                label={__(filter.labelKey)}
                id={filter.id}
                info={nbrBets}
              />
            );
          })}
        </HallOfFameFilters>

        <HallOfFameItems>
          {hallOfFameBetslipsIds[selectedFilter].map((betslipId, index) => {
            return <HallOfFameItemContainer id={betslipId} key={`${selectedFilter}-${betslipId}-${index}`} />;
          })}
        </HallOfFameItems>
      </HallOfFameWrapper>
    );
  }
  return null;
};

export default HallOfFame;
